// extracted by mini-css-extract-plugin
export default {"statusCell":"StatusCell_statusCell__VBaS2","contentWrapper":"StatusCell_contentWrapper__eIaBi","wasStatus":"StatusCell_wasStatus__hp1k0"};